var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loginAndRegisterSection"}},[_c('div',{staticClass:"w-100 d-flex justify-content-center"},[_c('AtlasLogo')],1),_c('div'),_vm._m(0),_c('LoginRegister',{ref:"LoginRegister",attrs:{"showFullForm":true}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"welcomeToAtlas"}},[_c('h4',[_vm._v("به فروشگاه ثریا خوش آمدید")])])
}]

export { render, staticRenderFns }